/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Status of a candidate's re-review request.
 */
export type ReviewRequestStatus =
  (typeof ReviewRequestStatus)[keyof typeof ReviewRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewRequestStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
